import { Theme } from "@mui/material/styles";

// ----------------------------------------------------------------------

export default function ControlLabel(theme: Theme) {
  return {
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          fontFamily: theme.typography.fontFamily,
        },
        label: {
          ...theme.typography.body2,
          fontFamily: theme.typography.fontFamily,
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          marginTop: theme.spacing(1),
          fontFamily: theme.typography.fontFamily,
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          color: theme.palette.text.disabled,
          fontFamily: theme.typography.fontFamily,
        },
      },
    },
  };
}
